/*
type:
  Primary
  Danger
*/

import "./Button.scss";
function Button({
  value,
  type,
  btnType,
  marginTop,
  marginLeft,
  marginBottom,
  marginRight,
  onClick,
}) {
  return (
    <button
      id={type}
      type={btnType}
      style={{ margin: marginTop, marginRight, marginBottom, marginLeft }}
      onClick={onClick}
    >
      {value}{" "}
    </button>
  );
}

export default Button;
